/**
 * Dữ liệu hiệu suất thực tế — SHC Team V1 / V3 / TB thị trường
 * ─────────────────────────────────────────────────────────────
 * Mỗi con số nằm trên một dòng riêng để dễ tìm và chỉnh sửa.
 *
 * Cách cập nhật hàng tháng:
 *  1. Thêm object mới vào mảng MONTHLY_DATA
 *  2. Cập nhật YTD_DATA với số tích lũy mới nhất
 */

// ─── Nhãn tháng theo ngôn ngữ ─────────────────────────────────────────────────
export const MONTH_LABELS = {
  vi: [
    '2022',
    '2023',
    '2024',
    '2025',
  ],
  en: [
    '2022',
    '2023',
    '2024',
    '2025',
  ],
  fr: [
    '2022',
    '2023',
    '2024',
    '2025',
  ],
  es: [
    '2022',
    '2023',
    '2024',
    '2025',
  ],
};

// ─── Dữ liệu từng tháng ───────────────────────────────────────────────────────
// Thứ tự phải khớp với MONTH_LABELS ở trên
export const MONTHLY_DATA = [
  // 2022
  {
    v1:     33.78,
    v3:     34.47,
    market: 5,
  },
  // 2023
  {
    v1:     30.42,
    v3:     32.72,
    market: 8,
  },
  // 2024
  {
    v1:     34.85,
    v3:     31.9,
    market: 9,
  },
  // 2025
  {
    v1:     32.43,
    v3:     35.89,
    market: 2,
  },
];

// ─── YTD (Year-to-Date) tích lũy ─────────────────────────────────────────────
export const YTD_DATA = {
  v1:     108.39,
  v3:     112.76,
  market:  6,
};
